import { LeadList } from "./LeadList";

export default {
  list: LeadList,
};
